"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1361],{

/***/ 61361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ HtmlBlock_HtmlBlock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/blocks/HtmlBlock/utils.ts
const getScriptContentFromHTMLString = (htmlString)=>{
    const parser = new DOMParser();
    const parsedHTML = parser.parseFromString(htmlString, "text/html");
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const [scriptElement] = parsedHTML.getElementsByTagName("script");
    return scriptElement && scriptElement.innerText;
};
const removeScriptTagFromHTMLString = (htmlString)=>{
    const SCRIPT_REGEX = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
    return htmlString.replace(SCRIPT_REGEX, "");
};

;// CONCATENATED MODULE: ./src/blocks/HtmlBlock/HtmlBlock.tsx



const HtmlBlock = (param)=>{
    let { blockData  } = param;
    const { background , html , picture , css  } = blockData;
    const backgroundImage = picture && "url('".concat("https://www-api.coderslab.si/").concat(picture.pictureUrl, "')");
    const htmlContentWithoutScripts = html ? removeScriptTagFromHTMLString(html) : html;
    const htmlContent = css ? "<style>".concat(css, "</style> ").concat(htmlContentWithoutScripts) : htmlContentWithoutScripts;
    (0,react.useEffect)(()=>{
        const scriptContent = getScriptContentFromHTMLString(html);
        if (scriptContent) {
            const script = document.createElement("script");
            script.async = true;
            script.type = "text/javascript";
            script.innerHTML = scriptContent;
            document.body.appendChild(script);
            return ()=>{
                document.body.removeChild(script);
            };
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            background,
            backgroundImage
        },
        dangerouslySetInnerHTML: {
            __html: htmlContent
        }
    });
};
/* harmony default export */ var HtmlBlock_HtmlBlock = (HtmlBlock);

;// CONCATENATED MODULE: ./src/blocks/HtmlBlock/index.tsx



/***/ })

}]);